import React, { useState } from "react";
import { useFormikContext } from "formik";
import amex from "../../../../../../../images/v2/amex24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import mastercard from "../../../../../../../images/v2/master24x24.svg";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import TextInput from "../../../../../components/form/text-input";
import Switch from "../../../../../components/form/switch";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import PinBasedDebit from "../components/pin-based-debit";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";

const IcPlus = () => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue } =
    useFormikContext();

  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  const [backup, setBackup] = useState({
    ic_plus_amex_rate: values?.ic_plus_amex_rate,
    ic_plus_amex_transaction_fee: values?.ic_plus_amex_transaction_fee
  });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Rate fees</h6>
            <div className={styles.accepts}>
              <img src={visa} />
              <img src={mastercard} />
              <img src={discover} />
            </div>
          </div>

          <div className={styles.body}>
            <TextInput
              label={"IC+ rate"}
              placeholder={"0.00"}
              suffix={"%"}
              type="text"
              inputMode="decimal"
              id={"ic_plus_rate"}
              name={"ic_plus_rate"}
              value={values.ic_plus_rate}
              onBlur={handleBlur}
              touched={touched?.ic_plus_rate}
              errored={errors?.ic_plus_rate}
              error={errors?.ic_plus_rate}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ic_plus?.ic_plus_rate?.soft_limit,
                values.ic_plus_rate,
                errors.ic_plus_rate,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ic_plus_rate",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
            <TextInput
              label={"Txn rate"}
              placeholder={"0.00"}
              prefix={"$"}
              type="text"
              inputMode="decimal"
              id={"ic_plus_transaction_fee"}
              name={"ic_plus_transaction_fee"}
              value={values.ic_plus_transaction_fee}
              onBlur={handleBlur}
              touched={touched?.ic_plus_transaction_fee}
              errored={errors?.ic_plus_transaction_fee}
              error={errors?.ic_plus_transaction_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.ic_plus?.ic_plus_transaction_fee?.soft_limit,
                values.ic_plus_transaction_fee,
                errors.ic_plus_transaction_fee,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "ic_plus_transaction_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
          </div>
        </div>
      </div>

      <div className={`${styles.container} ${styles.marginTop15}`}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Rate fees amex</h6>
            <div className={styles.accepts}>
              <img src={amex} />
            </div>
          </div>

          <Switch
            id={'ic_plus_amex_toggle'}
            name={'ic_plus_amex_toggle'}
            label="Enable Amex pricing"
            checked={values?.ic_plus_amex_toggle === "yes"}
            onChange={(e) => {
              handleChange(e);
              setFieldValue('ic_plus_amex_toggle', e.target.checked ? "yes" : "no");
              if (!e.target.checked) {
                setFieldValue("ic_plus_amex_rate", 0);
                setFieldValue("ic_plus_amex_transaction_fee", 0);
              }else {
                setFieldValue("ic_plus_amex_rate", backup.ic_plus_amex_rate);
                setFieldValue("ic_plus_amex_transaction_fee", backup.ic_plus_amex_transaction_fee);
              }
            }}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue('ic_plus_amex_toggle', e.target.checked ? "yes" : "no");
              if (!e.target.checked) {
                setFieldValue("ic_plus_amex_rate", 0);
                setFieldValue("ic_plus_amex_transaction_fee", 0);
              }else {
                setFieldValue("ic_plus_amex_rate", backup.ic_plus_amex_rate);
                setFieldValue("ic_plus_amex_transaction_fee", backup.ic_plus_amex_transaction_fee);
              }
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          {values?.ic_plus_amex_toggle === 'yes' && (
            <>
              <div className={styles.body}>
                <TextInput
                  label={"IC+ rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  inputMode="decimal"
                  id={"ic_plus_amex_rate"}
                  name={"ic_plus_amex_rate"}
                  value={values.ic_plus_amex_rate}
                  onBlur={handleBlur}
                  touched={touched?.ic_plus_amex_rate}
                  errored={errors?.ic_plus_amex_rate}
                  error={errors?.ic_plus_amex_rate}
                  hasWarning={getSoftLimitWarning(
                    pricingDefaults?.ic_plus?.ic_plus_amex_rate?.soft_limit,
                    values.ic_plus_amex_rate,
                    errors.ic_plus_amex_rate,
                  )}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "ic_plus_amex_rate",
                          value: e.target.rawValue,
                        },
                      });
                      setBackup({
                        ic_plus_amex_rate: e.target.rawValue,
                        ic_plus_amex_transaction_fee: values.ic_plus_amex_transaction_fee
                      });
                    },
                  }}
                  disabled={nonEditableTemplateOrPricingRestricted || values?.ic_plus_amex_toggle === 'no'}
                />
                <TextInput
                  label={"Txn rate"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  inputMode="decimal"
                  id={"ic_plus_amex_transaction_fee"}
                  name={"ic_plus_amex_transaction_fee"}
                  value={values.ic_plus_amex_transaction_fee}
                  onBlur={handleBlur}
                  touched={touched?.ic_plus_amex_transaction_fee}
                  errored={errors?.ic_plus_amex_transaction_fee}
                  error={errors?.ic_plus_amex_transaction_fee}
                  hasWarning={getSoftLimitWarning(
                    pricingDefaults?.ic_plus?.ic_plus_amex_transaction_fee
                      ?.soft_limit,
                    values.ic_plus_amex_transaction_fee,
                    errors.ic_plus_amex_transaction_fee,
                  )}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "ic_plus_amex_transaction_fee",
                          value: e.target.rawValue,
                        },
                      });
                      setBackup({
                        ic_plus_amex_rate: values.ic_plus_amex_rate,
                        ic_plus_amex_transaction_fee: e.target.rawValue
                      });
                    },
                  }}
                  disabled={nonEditableTemplateOrPricingRestricted || values?.ic_plus_amex_toggle === 'no'}
                />
              </div>
            </>
          )}

        </div>
      </div>

      <PinBasedDebit pricingModel="ic_plus" />
    </>
  );
};

export default IcPlus;
